import React from 'react';
import styles from './Login.module.css';
import Logo from '../../components/Logo';
import LoginForm from './LoginForm';
import SideBackground from '../../components/SideBackground';

export default function Login() {
  return (
    <div className={styles.loginRoot}>
      <div className={styles.loginLeft}>
        <Logo />
        <LoginForm />
      </div>
      <SideBackground>
        <div className={styles.loginBgOverlay}></div>
      </SideBackground>
    </div>
  );
} 